angular.module('callX')
    .directive('datePickerSection', ['DateService', function(DateService) {return {
        restrict: 'EA',
        templateUrl: 'tpl/blocks/date_picker_section.html',
        replace: true,
        transclude: true,
        scope: {
            dateChanged: '&'
        },
        controller: ['$scope', function ($scope)
        {
            var DateObj = DateService.getDateObj();
            var timezone = DateObj.timezone;
            $scope.dateRangeValue = DateObj.dateRangeValue;
            $scope.activeDate = DateObj.activeDate;
            $('#date-range-picker').val($scope.dateRangeValue[0] + " - " + $scope.dateRangeValue[1]);
            $scope.datepickerStartDate = $scope.dateRangeValue[0];
            $scope.datepickerEndDate = $scope.dateRangeValue[1];
            //$scope.datepickerStartDate = moment().tz(timezone).format("MMM D, YYYY");
            //console.log("dateObjUpdate",dateObjUpdate);

            $scope.$on('dateObjUpdate', function(event, dateObj) {
                //console.log("dateObjUpdate",dateObjUpdate);
                DateObj = dateObj;
                timezone = dateObj.timezone;
                $scope.dateRangeValue = DateObj.dateRangeValue;
                $scope.activeDate = DateObj.activeDate;
                $('#date-range-picker').val($scope.dateRangeValue[0] + " - " + $scope.dateRangeValue[1]);
                $scope.datepickerStartDate = $scope.dateRangeValue[0];
                $scope.datepickerEndDate = $scope.dateRangeValue[1];
                /*$scope.datepickerStartDate = moment().tz(timezone).format("MMM D, YYYY");
                 $scope.datepickerEndDate = moment().tz(timezone).format("MMM D, YYYY");*/
            });

            $( "#date-range-picker-button" ).on( "click", function() {
                $( "#date-range-picker" ).trigger( "click" );
            });

            $('#date-range-picker').on('apply.daterangepicker', function(ev, picker) {
                var range = $('#date-range-picker').val();
                $scope.dateRangeValue = range.split(" - ");
                if($scope.dateRangeValue == [moment().tz(timezone).format("MMM D, YYYY"), moment().tz(timezone).format("MMM D, YYYY")]){
                    $scope.activeDate = 'today';
                }
                else if($scope.dateRangeValue == [moment().add(-1, 'days').tz(timezone).format("MMM D, YYYY"), moment().add(-1, 'days').tz(timezone).format("MMM D, YYYY")]){
                    $scope.activeDate = 'yesterday';
                }
                else{
                    $scope.activeDate = 'custom';
                }
                // Schedule a safe digest; works even if a digest is already in progress
                $scope.$evalAsync();
                $scope.dateChanged({activeDate: $scope.activeDate, dateRangeValue: $scope.dateRangeValue});
                DateService.setDateObj($scope.activeDate, $scope.dateRangeValue);
            });

            $scope.activeDates = [
                {label: 'Today', value: 'today'},
                {label: 'Yesterday', value: 'yesterday'},
                {label: 'Last 7 days', value: 'seven-days'},
                {label: 'Last 30 days', value: 'thirty-days'},
                {label: 'Last Month', value: 'last-month'},
                {label: 'This Month', value: 'this-month'},
                {label: 'This Year', value: 'this-year'}
            ];

            $scope.setActiveDate = function(date){
                /*if(['today', 'yesterday', 'seven-days', 'thirty-days', 'this-month', 'this-year'].indexOf(date)>-1){
                 $scope.activeDate = date;
                 }
                 else{
                 $scope.activeDate = 'custom';
                 }*/

                $scope.activeDate = date;

                if(date == "today") {
                    $scope.dateRangeValue = [moment().tz(timezone).format("MMM D, YYYY"), moment().tz(timezone).format("MMM D, YYYY")];
                }
                else if(date == "yesterday") {
                    $scope.dateRangeValue = [moment().add(-1, 'days').tz(timezone).format("MMM D, YYYY"), moment().add(-1, 'days').tz(timezone).format("MMM D, YYYY")];
                }
                else if(date == "seven-days") {
                    $scope.dateRangeValue = [moment().add(-7, 'days').tz(timezone).format("MMM D, YYYY"), moment().add(-1, 'days').tz(timezone).format("MMM D, YYYY")];
                }
                else if(date == "thirty-days") {
                    $scope.dateRangeValue = [moment().add(-30, 'days').tz(timezone).format("MMM D, YYYY"), moment().add(-1, 'days').tz(timezone).format("MMM D, YYYY")];
                }
                else if(date == "last-month") {
                    $scope.dateRangeValue = [moment().subtract(1, 'months').tz(timezone).format("MMM 1, YYYY"), moment().subtract(1, 'months').endOf('month').tz(timezone).format("MMM D, YYYY")];
                }
                else if(date == "this-month") {
                    $scope.dateRangeValue = [moment().tz(timezone).format("MMM 1, YYYY"), moment().tz(timezone).format("MMM D, YYYY")];
                }
                else if(date == "this-year") {
                    var today = moment.tz({y:_year, M:0, d:1}, timezone);
                    var _year = today.get('year');
                    $scope.dateRangeValue = [moment.tz({y:_year, M:0, d:1}, timezone).format("MMM D, YYYY"), moment().tz(timezone).format("MMM D, YYYY")];
                }
                $scope.dateChanged({activeDate: $scope.activeDate, dateRangeValue: $scope.dateRangeValue});
                $('#date-range-picker').val($scope.dateRangeValue[0] + " - " + $scope.dateRangeValue[1]);
                DateService.setDateObj($scope.activeDate, $scope.dateRangeValue);
            }
        }]
    };
    }]);